module.exports = __webpack_public_path__ + "static/img/2.a2814ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/2.png
// module id = f7jX
// module chunks = 0